import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from 'src/app/services/account.service';
import { SectionDetailsComponent } from './section-details/section-details.component';
import { TemplateCreateComponent } from './template-create/template-create.component';

@Component({
  selector: 'app-section-view',
  templateUrl: './section-view.component.html',
  styleUrls: ['./section-view.component.css']
})
export class SectionViewComponent implements OnInit {
  accountId: number;
  sections: any = [];
  api_error: any;
  api_success: string;
  tempId: any;
  templates: any = [];
  constructor(private route: ActivatedRoute,
    private dialog: MatDialog, private router: Router, private activatedRoute: ActivatedRoute, private accountService: AccountService) { }
  ngOnInit(): void {
    this.route.parent.params.subscribe(params => {
      this.accountId = params['id'];
      this.getAccountTemplate()
    });
  }

  getAccountTemplate() {
    this.accountService.getTemplates(this.accountId)
      .subscribe(res => {
        this.templates = res;
      });
  }
  createTemplate(temp) {
    const dialogRef = this.dialog.open(TemplateCreateComponent, {
      width: '600px',
      data: { 'accountId': this.accountId ,'type': 'add' }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAccountTemplate()
    });
  }
  createSection(temp) {
    const dialogRef = this.dialog.open(SectionDetailsComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'templateId': temp.id, 'tempName': temp.templateName,}
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  deleteTemplate(temp) {
    this.api_error = '';
    this.accountService.deleteTemplate(this.accountId, temp.id)
      .subscribe(
        data => {
          this.api_success = 'template removed Successfully';
          this.getAccountTemplate()
        },
        (error) => {
          this.api_error = error.error;
        }
      );



  }
  updateTemplate(temp) {
    const dialogRef = this.dialog.open(TemplateCreateComponent, {
      width: '600px',
      data: { 'accountId': this.accountId ,'type': 'edit' , 'temp':  temp}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAccountTemplate()
    });
  }
  

}
